import { render } from "./DefaultCustomers.vue?vue&type=template&id=3c5c8645&scoped=true"
import script from "./DefaultCustomers.vue?vue&type=script&lang=js"
export * from "./DefaultCustomers.vue?vue&type=script&lang=js"

import "./DefaultCustomers.vue?vue&type=style&index=0&id=3c5c8645&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c5c8645"]])

export default __exports__